import { render } from "./SystemBar.vue?vue&type=template&id=2b88fa06"
import script from "./SystemBar.vue?vue&type=script&lang=js"
export * from "./SystemBar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Web\\Coonfia\\Mantenedor\\coonfia-mantenedor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__